import { supabase } from "@/integrations/supabase/client";

export type EntityType = "products" | "clients" | "suppliers" | "expense_categories" | "bank_accounts" | "profiles" | "transactions";

export const EntitiesIndexer = {
  upsert: async (params: { tenant_id: string; entity_type: EntityType; entity_id: string; title?: string | null; content: string; source_table?: string | null; attributes?: Record<string, unknown> | null; tags?: string[] | null }) => {
    const { error } = await supabase.functions.invoke("ai-qdrant-entities-upsert", { body: params } as any);
    if (error) throw error;
  },
  remove: async (params: { tenant_id: string; entity_type: EntityType; entity_id: string }) => {
    const { error } = await supabase.functions.invoke("ai-qdrant-entities-remove", { body: params } as any);
    if (error) throw error;
  },
  batch: async (params: { tenant_id: string; entity_type: EntityType }) => {
    const { data, error } = await supabase.functions.invoke("ai-qdrant-entities-batch", { body: params } as any);
    if (error) throw error;
    return data as any;
  },
};

